import { render, staticRenderFns } from "./scene13.vue?vue&type=template&id=93f92fd6&scoped=true&"
import script from "./scene13.vue?vue&type=script&lang=ts&"
export * from "./scene13.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f92fd6",
  null
  
)

export default component.exports